import React from 'react'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'

import MainModal from '../../../../components/dashboard/modal/MainModal'
import ErrorModalHead from '../../../../components/dashboard/modal/ErrorModalHead'
import InfoModalHead from '../../../../components/dashboard/modal/InfoModalHead'

import { P } from '../../../../style/Typography.style'

import { toggleJobPrioritization } from '../../../../store/actions/jobListingActions'

const ToggleJobPrioritization = ({ jobStatus }) => {
  const dispatch = useDispatch()

  let buttonText = 'Deprioritize Job'
  let modalHead = <ErrorModalHead title="Confirm Deprioritize Job" />
  let modalMessage =
    'Are you sure you want to deprioritize this job? Applicants will no longer be able to apply to this job until it has been re-activated.'

  if (jobStatus === 'deprioritized') {
    buttonText = 'Activate Job'
    modalHead = <InfoModalHead title="Confirm Activate Job" />
    modalMessage =
      'Are you sure you want to activate this job? Applicants will be able to apply to this job once it is activated.'
  }

  const { id } = useParams()

  const { loading } = useSelector((state) => state.jobListing)

  return (
    <MainModal
      isOpen={true}
      buttonText={buttonText}
      loading={loading}
      error={jobStatus !== 'deprioritized'}
      info={jobStatus === 'deprioritized'}
      onClick={() => dispatch(toggleJobPrioritization(id))}
      header={modalHead}
    >
      <P>{modalMessage}</P>
    </MainModal>
  )
}

export default ToggleJobPrioritization
